import { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { Dropdown } from "primereact/dropdown";
import { Column } from "primereact/column";
import { classNames } from "primereact/utils";
import { Controller, useForm } from "react-hook-form";
import { confirmDialog } from 'primereact/confirmdialog';
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { InputComponent } from "../../components/InputComponent";
import { ConfiguracionFactor } from "../../models/matriz/ConfiguracionFactor";
import { useLazyParams } from "../../hooks/useLazyParams";
import { TablaDinamica } from "../../components/TablaDinamica";

export const ConfiguracionFactorEmpresa = ({ factorSeleccionado, empresa, areaNegocio, tipo, toast, generic }) => {

    const monitoreoService = new MonitoreoService();
    const omodel = new ConfiguracionFactor();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const [permss, setPermss] = useState(null);
    const [factorRiesgoPadre, setFactorRiesgoPadre] = useState(null);
    const [dialogCatalogo, setDialogCatalogo] = useState(false);
    const [tiposAlerta, setTiposAlerta] = useState([]);
    const [rowSeleccionada, setRowSeleccionada] = useState(null);
    const menuRef = useRef(null);
    const ordenesRestringidos = [2, 3, 4, 5, 9, 10, 15, 16];
    const isRestringido = ordenesRestringidos.includes(factorSeleccionado?.orden_asignado);
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const { inArea, inNumber } = InputComponent({ registers: tablaEstado.data, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams]);

    useEffect(() => {
        if (factorSeleccionado?.orden_asignado === 22 && tipo === 'RIESGO_CLIENTE') {
            cargarTiposAlerta();
        }
    }, [factorSeleccionado]);

    const cargarTiposAlerta = () => {
        monitoreoService.consultarInfo('matriz/configuracion/tipos-alerta').then(res => {
            setTiposAlerta(res.data);
        }).catch(error => generic.funcErrorHibrida(error, toast));
    }

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;
        if (permss == null) _lazyParams.rtipo = true;

        const params = {
            factor: factorSeleccionado.id,
            tipo_negocio_id: areaNegocio?.cat_id,
            empresa_id: empresa.cat_id,
            tipo: tipo,
            lazyEvent: JSON.stringify(_lazyParams)
        };

        monitoreoService.consultarInfo('matriz/configuracion/lista-factor', params).then(res => {
            setFactorRiesgoPadre(res.data.idp);
            tablaEstado.setTotalRecords(res.data?.total);
            tablaEstado.setData(res.data?.registros);
            if (res.data?.perss !== undefined) setPermss(res.data.perss);
        }).catch(error => generic.funcErrorHibrida(error, toast, setError))
            .finally(() => tablaEstado.setLoading(false));
    }

    const abrirEdicion = (rowData) => {
        monitoreoService.consultar(rowData.id, 'matriz/configuracion/show-factor').then(res => {
            const dataCompleta = { ...res.data, ...rowData };
            reset(generic.renewValues(dataCompleta, omodel.model));
            setDialogCatalogo(true);
        }).catch(error => {
            generic.funcErrorHibrida(error, toast);
        });
    };

    const openNew = () => {
        reset(defaultValues);
        setDialogCatalogo(true);
    }

    const onSubmit = (data) => {
        const payload = {
            ...data,
            idp: factorRiesgoPadre,
            tipo: tipo,
            tipo_negocio_id: areaNegocio?.cat_id,
            empresa_id: empresa?.cat_id,
            con_catalogo: false,
        };

        if (data.id == null) {
            // El backend recibe valor1 en la creación, lo mapeamos
            payload.valor1 = data.valor;
            monitoreoService.nuevo(payload, 'matriz/configuracion/nuevo-factor').then(res => {
                generic.funcSuccess(res, toast);
                setDialogCatalogo(false);
                loadLazyData();
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError)
            });
        } else {
            monitoreoService.editar(payload, 'matriz/configuracion/editar-configuracion-factor').then(res => {
                generic.funcSuccess(res, toast);
                setDialogCatalogo(false);
                loadLazyData();
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError)
            });
        }
    }

    const deleteItem = (rowData) => {
        confirmDialog({
            message: `¿Está seguro de eliminar el factor: ${rowData.nombre}?`,
            header: 'Confirmar Eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => {
                monitoreoService.eliminar(rowData.id, 'matriz/configuracion/eliminar-factor', { tipo, empresa_id: empresa.cat_id, tipo_negocio_id: areaNegocio?.cat_id }).then(res => {
                    generic.funcSuccess(res, toast);
                    loadLazyData();
                }).catch(error => generic.funcDeleteError(error, toast));
            }
        });
    }

    const itemsMenu = [
        { label: 'Editar', icon: 'pi pi-pencil', command: () => abrirEdicion(rowSeleccionada) },
        { label: 'Eliminar', icon: 'pi pi-trash', className: 'text-red-500', command: () => deleteItem(rowSeleccionada) }
    ];

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-ellipsis-v" type="button" className="p-button-rounded p-button-text p-button-secondary"
                aria-controls="popup_menu" aria-haspopup onClick={(event) => { setRowSeleccionada(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '5rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const startContent = (
        !isRestringido && <Button icon="pi pi-plus" className="mr-2" onClick={openNew} title="Nuevo factor" label="Nuevo" />
    );

    return (
        <div className="card">
            <h5 className="mb-4">Configuración de: <span className="text-primary">{factorSeleccionado?.nombre}</span></h5>
            <Toolbar className="mb-4" start={startContent}></Toolbar>
            <Menu model={itemsMenu} popup ref={menuRef} id="popup_menu" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data}
                totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
            <Dialog visible={dialogCatalogo} header={getValues('id') == null ? "Nuevo factor" : "Editar factor"} modal
                className="p-fluid" onHide={() => setDialogCatalogo(false)} style={{ width: '500px' }}>
                <div className="pt-3"> {/* Agregamos un poco de padding superior para que respire */}
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="formgrid grid">
                            {inArea('nombre', 4, 30, 12, { readOnly: isRestringido, obl: '*' })}
                            {inNumber('valor', 2, false, { icon: 'pi pi-hashtag', iconPosition: 'left' }, 12)}
                            {factorSeleccionado?.orden_asignado === 22 && tipo === 'RIESGO_CLIENTE' && (
                                <div className="col-12 mt-3">
                                    <div className="p-3 border-round border-1 border-300 surface-50 shadow-1">
                                        <div className="field col-12 mt-2">
                                            <label htmlFor="tipo_alerta_id" className={classNames({ 'p-error': errors.tipo_alerta_id })}>
                                                <i className="pi pi-exclamation-triangle mr-2"></i>Categoría de Alerta (Opcional)
                                            </label>
                                            <Controller name="tipo_alerta_id" control={control} render={({ field, fieldState }) => (
                                                <Dropdown id={field.name} value={field.value ?? null} onChange={(e) => field.onChange(e.value ?? null)} options={tiposAlerta} optionLabel="nombre" optionValue="cat_id"
                                                    placeholder="Seleccione..." filter showClear className={classNames('w-full', { 'p-invalid': fieldState.error })} />
                                            )} />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="mt-4">
                            {generic.buttonsForms(setDialogCatalogo)}
                        </div>
                    </form>
                </div>
            </Dialog>
        </div>
    );
};